/* eslint-disable import/no-commonjs */
const routes = require('@clubmed/next-routes');

module.exports = routes()
  /*
   * EXTERNALS (FAQ)
   */
  .add('/fragments/footer', 'fragmentsFooter')

  /*
   * ERRORS
   */
  .add('/500', '/errors/InternalServerError')

  .add('/payment-notification/:paymentId/:locale', '/paymentNotification')

  /*
   * PLE
   */
  .add('/account', 'account')

  .add('/account/profile', '/account/profile')
  .add('/account/profile/:profileSection', '/account/profile')
  .add('/account/searches', '/account/searches')
  .add('/account/past-trips', '/account/pastTrips')
  .add('/account/future-trips', '/account/futureTrips')

  .add('/account/prepare-my-stay/:bookingId/stay/:stayId', '/account/prepareMyStay')
  .add('/account/bookings/:bookingId/stay/:stayId', '/account/bookingDetails')
  .add('/account/bookings/:bookingId/payment-confirmation', '/account/paymentConfirmation')
  .add('/account/sponsorship', '/account/sponsorship')

  .add('/agency/pick-your-room', '/account/pickYourRoomAgencyView')
  .add('/resort/pick-your-room', '/resort/pickYourRoomResortView')
  .add('/great-members', '/account/greatMembers')

  .add('/pre-payment', '/account/prePayment')
  .add('/payment-redirect', '/account/paymentRedirect')

  .add('/newsletter/s', 'newsletterSubscription')
  .add('/newsletter/c/:type', 'newsletterConfirmation')
  .add('/newsletter/u/:subscriptionId', 'newsletterUnsubscription')

  /*
   * BE
   */
  .add('/booking/:bookingStep', 'booking')
  .add('/iframe-callback', 'iframe-callback')
  .add('/confirmation', 'confirmation')
  .add('/option/c/:status', 'option')
  .add('/option-error/c/:status/:error_code', 'option-error')
  .add('/quick-search', 'quickSearch')
  .add('/proposal-pdf/:proposalId', 'proposalPdf')

  /*
   * SHOPPING
   */
  .add('/', 'index')
  .add('/s', 'search')
  .add('/siteplan', 'siteplan')
  .add('/comparator', 'comparator')
  .add('/prebookingform/success-seller', 'prebookingformSuccessSeller')
  .add('/themes/:slug', 'themes')
  .add('/articles/:slug', 'articles')
  .add('/c/CM2C/:departureDate/:arrivalDate', 'dynamicPage')
  // suffixed by * because some urls have multiple slashes
  // https://github.com/pillarjs/path-to-regexp#zero-or-more
  .add({
    catchAll: true,
    name: 'dynamicPage',
  });
